import { FORM_PATHS, openInModalOrPage } from '../../modals';
import CreateLeadForm from '../../../containers/Lead/Forms/CreateLeadForm';
import _ from 'lodash';

export const createLead = () => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.CreateLead, -1, _.cloneDeep(CreateLeadForm)));
};
